import { ReactNode } from "react";

interface CardBodyProps {
  body: ReactNode;
}

export const CardBody = ({ body }: CardBodyProps) => {
  if (!body) {
    return null;
  }

  return (
    <div className="mt-2 min-h-0 flex-1 overflow-hidden text-sm transition-colors duration-200 ease-in-out">
      {body}
    </div>
  );
};
